import { useEffect, useState } from 'react'
import Default from 'components/layouts/Default/Default';
import PerformancePage from 'components/templates/Performance/PerformancePage';

const Performance = () => {

  return (
    <Default>
        <div className="row">
          <div className="col-12">
            <PerformancePage />
          </div>
          
        </div>

    </Default>
  )
}
// const dashboard = () => {
//     return (<div>Dashboard</div>)
// }
export default (Performance);